import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-dashboard-message',
  templateUrl: './dashboard-message.component.html',
  styleUrls: ['./dashboard-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardMessageComponent implements OnInit {

  @Input()
  label: string;

  @Input()
  icon: string;

  constructor() { }

  ngOnInit() {
  }

}
